export default __webpack_public_path__ + "static/sobremesa-45434023d594142d532304301bd428a2.png";